import { Component } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import moment from 'moment';
import uuid from 'node-uuid';

import {
    loadDocumentViewerByTask,
    loadDocumentViewerByWorkflow,
    loadDocumentHistoryByWorkflow,
    unloadWorkflowViewer
} from 'workflow/actions/viewer';

import WorkflowDocument from '../components/WorkflowDocument/WorkflowDocument';
import Document from 'part11/components/Document/Document';
import LoadingComponent from 'common/permissions/components/LoadingComponent';


export class WorkflowDocumentViewer extends Component {
    componentDidMount() {
        const {
            taskId,
            workflowId,
            loadDocumentViewerByTask,
            shouldGoBack
        } = this.props;

        if (taskId) {
            loadDocumentViewerByTask(taskId, shouldGoBack);
        } else if (workflowId) {
            this._loadViewerByWorkflow(workflowId);
        }
    }

    componentWillUnmount() {
        const { unloadWorkflowViewer } = this.props;
        unloadWorkflowViewer();
    }

    _loadViewerByWorkflow(workflowId) {
        const { loadDocumentViewerByWorkflow, shouldGoBack } = this.props;
        const historyDateRange = {
            start: moment().startOf('day').toDate(),
            end: moment().endOf('day').toDate()
        };

        loadDocumentViewerByWorkflow(workflowId, historyDateRange, shouldGoBack);
    }

    render() {
        const {
            document,
            workflowId,
            loadDocumentHistoryByWorkflow,
            shouldShowFullViewer,
            noScroll,
            noHeader
        } = this.props;

        if (!document) {
            return <LoadingComponent />;
        }

        const DocumentViewer = shouldShowFullViewer ? Document : WorkflowDocument;

        return (
            <DocumentViewer
                noHeader={noHeader}
                noScroll={noScroll}
                document={document}
                loadDocumentHistory={shouldShowFullViewer ? loadDocumentHistoryByWorkflow.bind(this, workflowId) : null}
                shouldShowQuickActions={false}
                shouldShowBackLink={false}
                key={uuid.v4()}
            />
        );
    }
}

export default connect((state, props) => {
    const taskId = props.taskId || props.params && props.params.taskId;
    const workflowId = props.workflowId || null;
    const document = props.document || lodash.get(state, 'workflowViewer.document');
    const shouldShowFullViewer = props.shouldShowFullViewer || false;
    const shouldGoBack = props.shouldGoBack;

    return {
        taskId,
        workflowId,
        document,
        shouldShowFullViewer,
        shouldGoBack
    };
}, {
    loadDocumentViewerByTask,
    loadDocumentViewerByWorkflow,
    unloadWorkflowViewer,
    loadDocumentHistoryByWorkflow
})(WorkflowDocumentViewer);
